// components/common/FontWrapper.js
"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { DM_Sans, Tajawal } from "next/font/google";

const dmSans = DM_Sans({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800", "900"],
  variable: "--font-dm-sans",
  display: "swap",
});

const tajawal = Tajawal({
  subsets: ["arabic"],
  weight: ["400", "500", "700", "800", "900"],
  variable: "--font-tajawal",
  display: "swap",
});

const FontWrapper = ({ locale = "en", children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const fontClass = isMounted
    ? locale === "ar"
      ? "font-tajawal"
      : "font-dmsans"
    : "";

  return (
    <div className={`${dmSans.variable} ${tajawal.variable} ${fontClass}`}>
      {children}
    </div>
  );
};

FontWrapper.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default FontWrapper;
